module.exports = __webpack_public_path__ + "img/tooltip_06-vallone-litho-calce-grigio.b1bb8372.jpg";